/* eslint-disable @typescript-eslint/naming-convention */

import type { CountryListItem } from '@app/generated/api/model'

export interface Supplier {
  id?: number
  code?: string
  created_at?: string
  type?: string
  name?: string
  country_request?: Pick<CountryListItem, 'id' | 'code_iso' | 'code_iso_2' | 'label_en' | 'label_fr'>
}

export function newSupplier (): Supplier {
  return {
  }
}
